import styled from 'styled-components';
import { Text } from '@kl/components-v6';

export const StyledPromoContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 24px;
`;

export const StyledText = styled(Text)`
    flex: 1;
    max-width: 829px;
`;
